import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ApiIntegrationComponent } from './layout/topnavbar/apiIntegrationComponent';
import { UserVerifyComponent } from './login/userVerify/userVerify.component';



const routes: Routes = [
  {
    path: '', redirectTo: 'login', pathMatch: 'full'
  },
  {
    path: 'project', loadChildren: () => import("./project/project.module").then(m => m.ProjectModule)
  },
  {
    path: 'data', loadChildren: () => import("./data/data.module").then(m => m.DataModule)
  },
  {
    path: 'setting', loadChildren: () => import("./setting/setting.module").then(m => m.SettingModule)
  },
  {
    path: 'report', loadChildren: () => import("./report/report.module").then(m => m.ReportModule)
  },
  {
    path: 'test', loadChildren: () => import("./test/test.module").then(m => m.TestModule)
  },
  {
    path: 'workflow', loadChildren: () => import("./workflow/workflow.module").then(m => m.WorkflowModule)
  },
  {
    path: 'apiintegration', component: ApiIntegrationComponent
  },
  

  //RunManagementComponent
  
  // data-management
  // {
  //   path: 'data-management/:pid', component: DataComponent
  // },

  
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload',
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'top', relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
